/**
 * 替换函数
 */
type Replacer = (info: {
  seriesId: number
  seriesName: string
}) => Promise<string>
/**
 * 查找并替换车系名为链接
 * @param root 要查找元素的根节点
 * @param seriesList 车系列表，key为车系名，value为车系ID
 * @param replaceFunc 车系列表，key为车系名，value为车系ID
 */
export function replaceSeries(
  root: HTMLElement,
  seriesList: Record<string, number>,
  replacer: Replacer
) {
  const seriesNames = Object.keys(seriesList)
  // 已经匹配到的车系名
  // 对于奥迪A4L和奥迪A4这种情况
  // 优先匹配到奥迪A4L时，忽略对奥迪A4的匹配
  const matched: string[] = []
  // 替换element中命中的关键字
  function searchInElement(node: HTMLElement) {
    // 不处理a标签内部的文字
    if (node.tagName.toLowerCase() === 'a') {
      return
    }
    // 判断element时，直接遍历所有子节点: 替换text，递归调用element，直到所有的text都被替换
    const childrens = Array.from(node.childNodes)
    childrens.forEach(async node => {
      if (isHTMLElement(node)) {
        searchInElement(node)
      } else if (isText(node)) {
        searchInText(node)
      }
    })
  }
  // 查找textNode中的车系关键字并替换之
  async function searchInText(textNode: Text) {
    let text = textNode.textContent || ''
    /* eslint-disable no-await-in-loop */
    for (const name of seriesNames) {
      // 为了匹配更多车系
      // 1. 将全角转为半角
      // 2. 将汉字数字转为阿拉伯数字
      const fixedName = fixName(name)
      const includesName = text.toLowerCase().indexOf(fixedName)
      if (matched.some(key => key.includes(fixedName))) {
        return
      }
      if (includesName >= 0) {
        matched.push(fixedName)
        const targetName = text.slice(
          includesName,
          includesName + fixedName.length
        )
        const seriesId = seriesList[fixedName]
        const replaced = await replacer({ seriesId, seriesName: targetName })
        text = text.replace(new RegExp(targetName, 'i'), replaced)
      }
    }
    /* eslint-enable no-await-in-loop */
    const span = document.createElement('span')
    span.innerHTML = text
    textNode.replaceWith(span)
  }
  return () => {
    const elements = getElements(root)
    elements.forEach(searchInElement)
  }
}

/**
 * 或许需要替换的dom节点，过滤某些元素（image底部的caption等）
 * @param root
 */
function getElements(root: HTMLElement) {
  return Array.from(root.querySelectorAll('p')).filter(item => {
    return (
      !item.classList.contains('pgc-img-caption') &&
      !item.classList.contains('image-wrap')
    )
  })
}

function isHTMLElement(node: Node): node is HTMLElement {
  return node.nodeType === node.ELEMENT_NODE
}

function isText(node: Node): node is Text {
  return node.nodeType === node.TEXT_NODE
}

function fixName(text: string): string {
  const cnNums = '零一二三四五六七八九'.split('')
  const cnReg = new RegExp(cnNums.join('|'), 'g')
  return text
    .replace(/（/g, '(')
    .replace(/）/g, ')') // 车系匹配要匹配所有的全角和半角
    .replace(cnReg, cn => {
      return String(cnNums.indexOf(String(cn)))
    })
    .toLowerCase()
}
